import styles from './PurchaseTerms.module.scss'

import { DPA_URL, MSA_URL } from '@/constants/legal'

interface PurchaseTermsProps {
  /** Renders an invisible copy that holds the same height, so sibling cards keep their buttons aligned. */
  placeholder?: boolean
  className?: string
}

const PurchaseTerms = ({ placeholder = false, className }: PurchaseTermsProps) => {
  const classes = [styles.purchaseTerms, placeholder ? styles.placeholder : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  if (placeholder) {
    return (
      <p className={classes} aria-hidden="true">
        By purchasing, you agree to our MSA and DPA.
      </p>
    )
  }

  return (
    <p className={classes}>
      By purchasing, you agree to our{' '}
      <a href={MSA_URL} target="_blank" rel="noopener noreferrer">
        MSA
      </a>{' '}
      and{' '}
      <a href={DPA_URL} target="_blank" rel="noopener noreferrer">
        DPA
      </a>
      .
    </p>
  )
}

export default PurchaseTerms
